export default __webpack_public_path__ + "static/media/lorcana_uncommon.229400cf.svg";